import { Dialog, DialogContent, DialogContentText, Grid } from '@material-ui/core';
import moment from 'moment';
import { useEffect, useState } from 'react';
import { useHistory } from 'react-router-dom';
import { useAppDispatch, useAppSelector } from '../../app/hooks';
import { authLogout, selectGovBr } from '../../auth/authSlice';
import { currencyFormat, formatarCEI, formatarCNPJ, formatarCompetencia, formatarCpf, obterMesAnoExtenso } from '../../common/formatadores';
import Accordion, { SCROLL_OFFSET_NAV_FIXED } from '../../components/Accordion/Accordion';
import Card from '../../components/Card/Card';
import FieldGroup from '../../components/FieldGroup/FieldGroup';
import MainContainer from '../../components/MainContainer/MainContainer';
import { selectLoading, selectLoadingCount } from '../../globalSlice';
import { SituacaoCadastroFamiliaUsuario } from '../../model/SituacaoCadastroFamiliaUsuario';
import { selectLogado } from '../IdentificacaoPositiva/identificacaoPositivaSlice';
import styles from './ConsultaRenda.module.css';
import imgErro from '../../assets/img/icone-erro.png';
import BrButton from '@govbr/react-components/lib/BrButton';
import * as Mensagens from '../../common/Mensagens';

import Skeleton from 'react-loading-skeleton';
import 'react-loading-skeleton/dist/skeleton.css';

import {
  alterarDadosPessoaSelecionada,
  alterarSistemaParceiroIndisponivel,
  getDadosRendaAtualizada,
  selectDadosPessoaSelecionada,
  selectDadosRendaAtualizada,
  selectDadosRendaCNIS,
  selectIsRendaIdentificada,
  selectMembro,
  selectSistemaParceiroIndisponivel,
  selectState
} from './consultaRendaSlice';
import { selectPerfilCompleto, selectSituacaoCadastroFamilia } from '../Perfil/perfilSlice';
import Message from '../../components/Message/Message';
import AjudaRapida from '../../components/AjudaRapida/AjudaRapida';
import { obterNomeDoPerfil,obterNomePessoa } from '../../common/perfilUtils';
import { trackServiceSelect } from '../../common/tracker';

const RendaCnis: React.FC = () => {

  const isRendaIdentificada = useAppSelector(selectIsRendaIdentificada);
  const history = useHistory();
  const dispatch = useAppDispatch();

  const [dialogoExplicacao, setDialogoExplicacao] = useState(false);
  const [descricaoExplicacao, setDescricaoExplicacao] = useState('');

  const perfil = useAppSelector(selectPerfilCompleto);

  const situacaoCadastroFamilia = useAppSelector(selectSituacaoCadastroFamilia);
  const state = useAppSelector(selectState);

  const govBrLogado = useAppSelector(selectGovBr).logado;
  const isAuthenticatedIdPositiva = useAppSelector(selectLogado);
  const dadosRendaCNIS:any = useAppSelector(selectDadosRendaCNIS);
  const dadosRendaAtualizada:any = useAppSelector(selectDadosRendaAtualizada);
  const dadoPessoaSelecionada = useAppSelector(selectDadosPessoaSelecionada);

  const temBeneficioPrevidenciario = !!dadoPessoaSelecionada?.rendasBeneficios?.beneficios?.length;
  const temBeneficioRpps = !!dadoPessoaSelecionada?.rendasBeneficios?.beneficiosRpps?.length;
  const temSeguroDesemprego = dadoPessoaSelecionada?.rendasSeguroDesemprego?.total && dadoPessoaSelecionada?.rendasSeguroDesemprego?.total !== "0" ? true : false;
  const temRendaOutrasFontes = dadoPessoaSelecionada?.rendasOutrasFontes?.total && dadoPessoaSelecionada?.rendasOutrasFontes?.total !== "0" ? true : false;

  const membro = useAppSelector(selectMembro);

  const loadingCount = useAppSelector(selectLoadingCount);
  const isLoading = useAppSelector(selectLoading);

  const sistemaParceiroIndisponivel = useAppSelector(selectSistemaParceiroIndisponivel);

  if (isRendaIdentificada) {
    const rendaCnis = dadosRendaCNIS.find(item => item.idPessoa === membro.idPessoa);
    if (rendaCnis) {
      dispatch(alterarDadosPessoaSelecionada(rendaCnis.dadosRenda));
    }
  } else {
    const rendaAtualizada = dadosRendaAtualizada.find(item => item.idPessoa === membro.idPessoa);
    if (rendaAtualizada) {
      dispatch(alterarDadosPessoaSelecionada(rendaAtualizada.dadosRenda));
    }
  }

  useEffect(() => {
    if (
      situacaoCadastroFamilia?.situacaoCadastroFamiliaUsuario !==
      SituacaoCadastroFamiliaUsuario.USUARIO_COM_FAMILIA_CADASTRADA &&
      !situacaoCadastroFamilia?.temRL
    ) {
      history.replace('/home');
    }
  }, [dispatch, situacaoCadastroFamilia, history]);

  useEffect(() => {
    const rootEl = document.getElementById('root');
    rootEl?.scrollTo(0, 0);
  }, [state]);

  const caixaMensagens = () => {
    trackServiceSelect('POR-MENU', "CAIXA DE MENSAGEM");
    history.push('/caixa-mensagem');
  };

  const isLogado = () => {
    return (govBrLogado && situacaoCadastroFamilia) || isAuthenticatedIdPositiva
      ? true
      : false;
  }

  const logout = () => {
    dispatch(authLogout({ history }));
  };

  const mostrarParentesco = (membro: any) => {
    if (membro?.parentesco === 'Pessoa Responsável pela Unidade Familiar - RF') {
      return 'Responsável Familiar - RF';
    }
    return membro?.parentesco;
  };

  const mostrarTipoEmpregador = (e: any) => {
    switch (e.tipoEmpregador) {
      case 'CPF': {
        return "CPF: " + formatarCpf(e.numero);
      }
      case 'CNPJ': {
        return "CNPJ: " + formatarCNPJ(e.numero);
      }
      case 'CEI': {
        return "CEI: " + formatarCEI(e.numero);
      }
      default:
        return "CPF/CNPJ/CEI: " + e.numero;
    }
  };

  const mostrarCompetenciaUltimos12Meses = (competencias: any) => {
    return competencias?.map((c, i) => {
      const mes = obterMesAnoExtenso(c.competenciaReferencia);
      return <div key={i}>{currencyFormat(c.valorRemuneracao)} ({mes?.mesExtenso.toLowerCase()}/{mes?.anoCompetencia})</div>
    })
  }

  const obterCompetencia = (competencia: any) => {
    const mes = obterMesAnoExtenso(competencia);
    return `${mes?.mes}/${mes?.anoCompetencia}`;
  }

  const obterQuantidadeRemuneracoes = (e) => {
    if (isRendaIdentificada) {
      if (e.competencias.length > 1) {
        return ` (${e.competencias.length} remunerações)`
      } else {
        return ` (${e.competencias.length} remuneração)`
      }
    }

    if (e.quantidadeRemuneracoesPovoadas > 1) {
      return ` (${e.quantidadeRemuneracoesPovoadas} remunerações)`
    } else {
      return ` (${e.quantidadeRemuneracoesPovoadas} remuneração)`
    }
  }

  const exibirBeneficiosPrevidenciarios = () => {
    return (
      <>
        <div className={styles.cardHeader}>
          <i className={`fas fa-solid fa-hands-helping ${styles.cardIcon}`}></i>
          <span className={styles.cardHeaderTitle}>
            Aposentadoria, aposentadoria rural, pensão ou BPC/LOAS
          </span>
        </div>
        <Card>
          <Grid container spacing={2}>
            <Grid item xs={12}>

              {(temBeneficioPrevidenciario || temBeneficioRpps) && (
                  <FieldGroup
                    label="Aposentadoria, aposentadoria rural, pensão ou BPC/LOAS"
                    value={
                      dadoPessoaSelecionada?.rendasBeneficios?.total
                        ? currencyFormat(dadoPessoaSelecionada?.rendasBeneficios?.total)
                        : '-'
                    }
                  />
              )}
              
              {temBeneficioPrevidenciario && (
                <>
                  <div className={styles.cardHeaderInternal}>
                    <div className={styles.cardTitleInternal}>
                      <span>Benefícios Previdenciários</span>
                    </div>
                  </div>


                  <Grid item xs={12}>
                    {dadoPessoaSelecionada.rendasBeneficios?.beneficios?.map((beneficio, index) => {
                      return (
                        <div key={index}>
                          <Accordion
                            id={`beneficios-${index}`}
                            title={'Espécie'}
                            subtitle={`${beneficio.especie.codigo} - ${beneficio.especie.descricao}`}
                            textoExplicativo={'Código e tipo do benefício pago ao cidadão'}
                            key={index}
                            styleContent={styles.styleContent}
                            className={styles.borderAccordion}
                            open={true}
                            textoDetalhamento="Detalhar"
                            exibirSubtitulo
                          >
                            <Grid container spacing={2}>
                              <Grid item xs={6}>
                                <FieldGroup label="Número de benefício" value={beneficio.nb} />
                              </Grid>

                              {isRendaIdentificada && (
                                <Grid item xs={6}>
                                  <FieldGroup
                                    label={
                                      <>
                                        <div>
                                          Competência
                                          <i
                                            className={`fas fa-question-circle ${styles.helpIcon}`}
                                            onClick={() => handleExplicacao('Mês do pagamento')}
                                          />
                                        </div>
                                      </>
                                    }
                                    value={obterCompetencia(beneficio.competencia)}
                                  />
                                </Grid>
                              )}

                              <Grid item xs={6}>
                                <FieldGroup
                                  label="Data início pagamento"
                                  value={
                                    beneficio.dataInicioPagamento
                                      ? moment(beneficio.dataInicioPagamento).format('DD/MM/YYYY')
                                      : ''
                                  }
                                />
                              </Grid>
                              <Grid item xs={6}>
                                <FieldGroup
                                  label="Valor do benefício"
                                  value={
                                    <div className={styles.espaco}>
                                      {isRendaIdentificada
                                        ? currencyFormat(beneficio.valor)
                                        : currencyFormat(beneficio.valorTotalRemuneracoesPovoadas)}
                                    </div>
                                  }
                                />
                              </Grid>
                            </Grid>
                          </Accordion>
                        </div>
                      );
                    })}
                  </Grid>
                </>
              )}

              {temBeneficioRpps && (
                <>
                  <div className={styles.cardHeaderInternal}>
                    <div className={styles.cardTitleInternal}>
                      <span>Benefícios Regime Próprio de Previdência Social</span>
                    </div>
                  </div>

                  <Grid item xs={12}>
                    {dadoPessoaSelecionada.rendasBeneficios?.beneficiosRpps?.map((beneficio, index) => {
                      return (
                        <div key={index}>
                          <Accordion
                            id={`beneficios-${index}`}
                            title={'Número de benefício'}
                            subtitle={beneficio.nb}
                            textoExplicativo={
                              'Código de identificação de seu benefício no sistema. Usado apenas para identificação.'
                            }
                            key={index}
                            styleContent={styles.styleContent}
                            className={styles.borderAccordion}
                            open={true}
                            textoDetalhamento="Detalhar"
                            exibirSubtitulo
                          >
                            <Grid container spacing={2}>
                              {isRendaIdentificada && (
                                <Grid item xs={6}>
                                  <FieldGroup
                                    label={
                                      <>
                                        <div>
                                          Competência
                                          <i
                                            className={`fas fa-question-circle ${styles.helpIcon}`}
                                            onClick={() => handleExplicacao('Mês do pagamento')}
                                          />
                                        </div>
                                      </>
                                    }
                                    value={obterCompetencia(beneficio.periodo)}
                                  />
                                </Grid>
                              )}

                              <Grid item xs={6}>
                                <FieldGroup
                                  label="Data início pagamento"
                                  value={
                                    beneficio.dataInicioBeneficio
                                      ? moment(beneficio.dataInicioBeneficio).format('DD/MM/YYYY')
                                      : ''
                                  }
                                />
                              </Grid>
                              <Grid item xs={6}>
                                <FieldGroup
                                  label="Valor do benefício"
                                  value={
                                    <div className={styles.espaco}>{currencyFormat(beneficio.valor)}</div>
                                  }
                                />
                              </Grid>
                            </Grid>
                          </Accordion>
                        </div>
                      );
                    })}
                  </Grid>
                </>
              )}

              {!temBeneficioPrevidenciario && !temBeneficioRpps && (
                <>
                  Não foi identificado benefício previdenciário ou BPC/LOAS para o(a) integrante
                  familiar nas bases do Governo Federal
                </>
              )}
              
            </Grid>
          </Grid>
        </Card>
      </>
    );
  };

  const exibirSeguroDesemprego = () => {
    return (
      <>
        <div className={styles.cardHeader}>
          <i className={`fas fa-solid fa-file-invoice-dollar ${styles.cardIcon}`}></i>
          <span className={styles.cardHeaderTitle}>Seguro-desemprego ou defeso</span>
        </div>

        <Card>
          <Grid container spacing={2}>
            <Grid item xs={12}>
              {temSeguroDesemprego &&
                <FieldGroup label="Seguro-desemprego ou defeso" value={dadoPessoaSelecionada.rendasSeguroDesemprego ?
                  currencyFormat(dadoPessoaSelecionada.rendasSeguroDesemprego?.total) : "-"} />
              }
              {!temSeguroDesemprego &&
                <>Não foi identificado seguro-desemprego ou defeso para o(a) integrante familiar nas bases do Governo Federal</>
              }
            </Grid>
            <Grid item xs={12}>
              {dadoPessoaSelecionada.rendasSeguroDesemprego?.parcelas?.map((p, i) => {
                return (
                  <div key={i}>
                    <Accordion
                        id={`seguroDesemprego-${i}`}
                        title={"Modalidade"}
                        subtitle={p.modalidade}
                        textoExplicativo={"Tipo do benefício pago ao cidadão"}
                        key={i}
                        styleContent={styles.styleContent}
                        className={styles.borderAccordion}
                        open={true}
                        textoDetalhamento='Detalhar'
                        exibirSubtitulo>
                      <Grid container spacing={2}>
                        <Grid item xs={12}>
                          <FieldGroup label="CNPJ/CEI" value={formatarCNPJ(p.pessoaJuridica?.cnpj)} />
                        </Grid>
                        <Grid item xs={6}>
                          <FieldGroup label="Nome do empregador" value={p.pessoaJuridica?.nomeFantasia} />
                        </Grid>
                        <Grid item xs={6}>
                          <FieldGroup
                            label={<>
                              <div>Competência
                                <i
                                  className={`fas fa-question-circle ${styles.helpIcon}`}
                                  onClick={() => handleExplicacao('Mês do pagamento')}
                                />
                              </div>
                            </>}
                            value={obterCompetencia(p.competencia)}
                          />
                        </Grid>
                        <Grid item xs={12}>
                          <FieldGroup label="Valor da remuneração" value={<div className={styles.espaco}>{currencyFormat(p.valorParcela)}</div>} />
                        </Grid>
                      </Grid>
                    </Accordion>
                  </div>
                  )
                })
              }
            </Grid>
          </Grid>
        </Card>
      </>
    )
  }

  const exibirOutrasFontes = () => {
    return (
      <>
        <div className={styles.cardHeader}>
          <i className={`fas fa-solid fa-dollar-sign ${styles.cardIcon}`}></i>
          <span className={styles.cardHeaderTitle}>Outras fontes</span>
        </div>

        <Card>
          <Grid container spacing={2}>
            <Grid item xs={12}>
              {temRendaOutrasFontes &&
                <FieldGroup label="Outras fontes de remuneração exceto bolsa família ou outras transferências similares" value={dadoPessoaSelecionada?.rendasOutrasFontes ?
                  currencyFormat(dadoPessoaSelecionada?.rendasOutrasFontes?.total) : "-"} />
              }
              {!temRendaOutrasFontes &&
                <>Não foi identificada outra fonte de renda para o(a) integrante familiar nas bases do Governo Federal</>
              }
            </Grid>
            <Grid item xs={12}>
              {dadoPessoaSelecionada.rendasOutrasFontes?.beneficios?.map((b, i) => {
                return (
                  <div key={i}>
                    <Accordion
                        id={`seguroDesemprego-${i}`}
                        title={"Modalidade"}
                        subtitle={`${b.especie.codigo} - ${b.especie.descricao}`}
                        textoExplicativo={"Tipo do benefício pago ao cidadão"}
                        key={i}
                        styleContent={styles.styleContent}
                        className={styles.borderAccordion}
                        open={true}
                        textoDetalhamento='Detalhar'
                        exibirSubtitulo>
                          <Grid container spacing={2}>
                            <Grid item xs={6}>
                              <FieldGroup label="Número do benefício" value={b.nb} />
                            </Grid>
                            {isRendaIdentificada && (
                              <Grid item xs={6}>
                                <FieldGroup
                                  label={<>
                                    <div>Competência
                                      <i
                                        className={`fas fa-question-circle ${styles.helpIcon}`}
                                        onClick={() => handleExplicacao('Mês do pagamento')}
                                      />
                                    </div>
                                  </>}
                                  value={obterCompetencia(b.competencia)}
                                />
                              </Grid>
                            )}
                            <Grid item xs={6}>
                              <FieldGroup label="Data início pagamento" value={moment(b.dataInicioPagamento).format('DD/MM/YYYY')} />
                            </Grid>
                            <Grid item xs={6}>
                              <FieldGroup label="Valor do benefício" value={<div className={styles.espaco}>{isRendaIdentificada ? currencyFormat(b.valor) : currencyFormat(b.valorTotalRemuneracoesPovoadas)}</div>} />
                            </Grid>
                          </Grid>
                        </Accordion>
                  </div>
                  )
                })
              }
            </Grid>
          </Grid>
        </Card>
      </>
    )
  }

  const handleExplicacao = (textoExplicativo) => {
    setDialogoExplicacao(!dialogoExplicacao);
    setDescricaoExplicacao(textoExplicativo);
  };

  const temRemuneracao = () => {
    return dadoPessoaSelecionada.remuneracaoUltimoMes?.remuneracoes || dadoPessoaSelecionada.remuneracaoUltimos12Meses?.remuneracoes;
  }

  const cardInformacoesBasicas = (
    <>
      <Dialog
          open={dialogoExplicacao}
          onClose={() => setDialogoExplicacao(false)}
        >
        <DialogContent>
          <DialogContentText>
            <div className={styles.textoDialogo}> {descricaoExplicacao}</div>
          </DialogContentText>
        </DialogContent>
      </Dialog>

      {isRendaIdentificada && <div className={styles.aviso}>Abaixo, você pode consultar as rendas identificadas no CNIS nos últimos 12 meses</div>}
      {!isRendaIdentificada && <div className={styles.aviso}>Abaixo, você pode ver as rendas que o Governo Federal colocou automaticamente no Cadastro Único da sua família</div>}
      <div className={styles.periodoReferencia}><strong>{isRendaIdentificada ? `Mês de referência` : `Mês da atualização`}: &nbsp;</strong>{formatarCompetencia(dadoPessoaSelecionada?.competenciaReferencia)}
        {!isRendaIdentificada && <i className={`fas fa-question-circle ${styles.helpIconExternal}`}
          onClick={() => handleExplicacao("Mês no qual a renda da pessoa foi atualizada automaticamente na base do Cadastro Único a partir de informações do Cadastro Nacional de Informações Sociais (CNIS).")}
        />}
      </div>
      <hr className={styles.separator}></hr>

      <Card>
        <div className={styles.responsavelFamiliar}>
          <i className={`fas fa-solid fa-id-card-alt ${styles.icon}`} />
          <div className="flex-column">
            <span className={styles.nomeResponsavel}>{obterNomePessoa(membro)}</span>
            <span className="fw500">{mostrarParentesco(membro)}</span>
          </div>
        </div>
      </Card>

      <div className={styles.cardHeader}>
        <i className={`fas fa-solid fa-user-tie ${styles.cardIcon}`}></i>
        <span className={styles.cardHeaderTitle}>{`${isRendaIdentificada ? "Renda de emprego formal" : "Rendas de trabalho"}`}</span>
      </div>

      <Card>
        <Grid container spacing={2}>

          {(!dadoPessoaSelecionada.remuneracaoUltimoMes && !dadoPessoaSelecionada.remuneracaoUltimos12Meses) &&
            <>Não foi identificada renda formal para o(a) integrante familiar nas bases do Governo Federal</>
          }

          {(dadoPessoaSelecionada.remuneracaoUltimoMes || dadoPessoaSelecionada.remuneracaoUltimos12Meses) &&
            <>
              <Grid item xs={12}>
                <FieldGroup
                  label={<>
                    <div>Remuneração de trabalho do mês anterior
                      <i
                        className={`fas fa-question-circle ${styles.helpIcon}`}
                        onClick={() => handleExplicacao('Valor do salário bruto recebido no último mês')}
                      />
                    </div>
                  </>}
                  value={
                    dadoPessoaSelecionada.remuneracaoUltimoMes?.total ?
                      currencyFormat(dadoPessoaSelecionada.remuneracaoUltimoMes?.total)
                      : '-'
                  }
                />
              </Grid>

              <Grid item xs={12}>
                <FieldGroup label={`${isRendaIdentificada ? "Quantidade de meses de trabalho remunerado nos últimos 12 meses" : "Quantidade de remunerações nesse período"}`}
                  value={dadoPessoaSelecionada.remuneracaoUltimos12Meses?.qtdeMesesTrabalhados} />
              </Grid>

              <Grid item xs={12}>
                <FieldGroup
                  label={<>
                    <div>Remuneração bruta de todos os trabalhos nesse período
                      <i
                        className={`fas fa-question-circle ${styles.helpIcon}`}
                        onClick={() => handleExplicacao('Soma de todos os salários brutos recebidos nos últimos 12 meses')}
                      />
                    </div>
                  </>}
                  value={
                    dadoPessoaSelecionada.remuneracaoUltimos12Meses?.total ?
                      currencyFormat(dadoPessoaSelecionada.remuneracaoUltimos12Meses?.total)
                      : '-'
                  }
                />
              </Grid>
            </>
          }
        </Grid>
        <Grid container spacing={2}>
          <Grid item xs={12}>
            { (temRemuneracao() && (dadoPessoaSelecionada.remuneracaoUltimoMes || dadoPessoaSelecionada.remuneracaoUltimos12Meses)) &&
              <>
                  {dadoPessoaSelecionada.empregos && dadoPessoaSelecionada.empregos?.length > 0 &&
                    <div className={styles.cardHeaderInternal}>
                      <i className={`fas fa-solid fa-warehouse ${styles.cardIconInternal}`}></i>
                      <span className={styles.cardTitleInternal}>Empregadores</span>
                    </div>
                  }
                  {dadoPessoaSelecionada.empregos?.map((e, i) => {
                    return (
                      <div key={i}>
                        <Accordion
                          id={`remuneracao-${i}`}
                          title={ `Empregador: ${e.nome ? e.nome?.toUpperCase()  : '-'}`}
                          observationTitle={obterQuantidadeRemuneracoes(e)}
                          subtitle={mostrarTipoEmpregador(e)}
                          key={i}
                          styleContent={styles.styleContent}
                          className={styles.borderAccordion}
                          open={true}
                          textoDetalhamento='Detalhar'
                          exibirSubtitulo>
                            <Grid container spacing={2}>
                              <Grid item xs={6}>
                                <FieldGroup label="Data de admissão" value={moment(e.dataAdmissao).format('DD/MM/YYYY')} />
                              </Grid>
                              <Grid item xs={6}>
                                <FieldGroup label="Data de rescisão" value={e.dataRescisao ? moment(e.dataRescisao).format('DD/MM/YYYY') : ""} />
                              </Grid>
                              <Grid item xs={12}>
                                <FieldGroup label="Ocupação" value={e.cbo?.descricao} />
                              </Grid>
                              <Grid item xs={12}>
                                {isRendaIdentificada && <FieldGroup label="Remuneração (últimos 12 meses) " value={<div className={styles.espaco}>{mostrarCompetenciaUltimos12Meses(e.competencias)}</div>} />}
                                {!isRendaIdentificada && <FieldGroup label="Remuneração bruta total (últimos 12 meses) " value={<div className={styles.espaco}>{currencyFormat(e.remuneracaoBrutaTotal12MesesPovoada)}</div>} /> }
                              </Grid>
                            </Grid>
                        </Accordion>
                      </div>
                      )
                    })
                  }
              </>
            }

            {temRemuneracao() && (dadoPessoaSelecionada.beneficios && dadoPessoaSelecionada.beneficios?.length > 0 ) &&
              <>
                <div className={styles.cardHeaderInternal}>
                  <i className={`fas fa-solid fa-briefcase ${styles.cardIconInternal}`}></i>
                  <span className={styles.cardTitleInternal}>Benefícios para trabalhador(a)</span>
                </div>
                {dadoPessoaSelecionada.beneficios?.map((b, i) => {
                  return (
                    <div key={i}>
                      <Accordion
                        id={`beneficios-${i}`}
                        title={"Espécie"}
                        subtitle={`${b.especie.codigo} - ${b.especie.descricao}`}
                        observationTitle={`${isRendaIdentificada ? obterQuantidadeRemuneracoes(b) : ""}`}
                        textoExplicativo = {"Código e tipo do benefício pago ao cidadão"}
                        key={i}
                        styleContent={styles.styleContent}
                        className={styles.borderAccordion}
                        open={true}
                        textoDetalhamento='Detalhar'
                        exibirSubtitulo>
                        <Grid container spacing={2}>
                          <Grid item xs={6}>
                            <FieldGroup label="Número de benefício" value={b.nb} />
                          </Grid>
                          <Grid item xs={6}>
                            <FieldGroup label="Data início pagamento" value={b.dataInicioPagamento ? moment(b.dataInicioPagamento).format('DD/MM/YYYY') : ""} />
                          </Grid>
                          <Grid item xs={12}>
                            {isRendaIdentificada && <FieldGroup label="Remunerações (últimos 12 meses) " value={<div className={styles.espaco}>{mostrarCompetenciaUltimos12Meses(b.competencias)}</div>} />}
                            {!isRendaIdentificada && <FieldGroup label="Remuneração bruta total (últimos 12 meses) " value={<div className={styles.espaco}>{currencyFormat(b.valorTotalRemuneracoesPovoadas)}</div>} /> }
                          </Grid>
                        </Grid>
                      </Accordion>
                    </div>
                  )
                })}
              </>
            }
          </Grid>
        </Grid>
      </Card>
    </>
  );

  const goBack = () => {
    dispatch(alterarSistemaParceiroIndisponivel(false));
    history.goBack();
  }

  return (
    <MainContainer
      userNav={isLogado()}
      navTitle={obterNomeDoPerfil(perfil, situacaoCadastroFamilia)}
      titleBarraAuxiliar={isRendaIdentificada ? "Renda identificada no CNIS" : "Renda atualizada automaticamente pelo Governo Federal"}
      barraAuxiliar={true}
      stoppedTitle={true}
      navFixed
      navGoBack={() => goBack()}
      navSeparator
      navCaixaMensagens={isLogado() ? caixaMensagens : undefined}
      navLogout={isLogado() ? logout : undefined}>
        <div className={styles.container}>
          {isLoading || loadingCount > 0 &&
            <>
              <br />
              <Skeleton count={5} />
            </>
          }

          {!isLoading && loadingCount === 0 && sistemaParceiroIndisponivel &&
            <Card className={styles.card}>
              <div className={styles.containerMensagem}>
                <img className={styles.imgMessage} src={imgErro} alt="Imagem de erro"/>
                <Message type={'error'}
                  text={
                    <>
                      <div className={styles.message}>
                        <span>{Mensagens.MSG_TENTE_NOVAMENTE}</span>
                      </div>
                    </>
                  }
                />
                <div className={styles.botaoContainer}>
                  <BrButton onClick={()=>goBack()}
                    className={styles.botao}>
                      OK
                  </BrButton>
                </div>
              </div>
            </Card>
          }

          {!isLoading && loadingCount === 0 && !sistemaParceiroIndisponivel &&
            <>
              {cardInformacoesBasicas}
              {exibirBeneficiosPrevidenciarios()}
              {isRendaIdentificada && exibirSeguroDesemprego()}
              {exibirOutrasFontes()}
              {!isRendaIdentificada &&
                <Message
                  type="warning"
                  className={styles.messageExternal}
                  title={`Se a pessoa tiver perdido esta renda nos últimos 2 meses, procure um posto de atendimento do Cadastro Único com os documentos que comprovem a informação e atualize o seu cadastro.`}
                />
              }

              <AjudaRapida scrollOffset={SCROLL_OFFSET_NAV_FIXED}>
                <div className={styles.textoAjudaRapida}>
                  {isRendaIdentificada && <>
                    <strong>Consulta de renda identificada no CNIS</strong>
                    <br />
                    <br />
                    Permite consultar as rendas identificadas no CNIS nos últimos 12 meses. São informações de rendas de trabalho ou benefícios pagos pelo INSS. Essas informações são atualizadas mensalmente.
                    <br />
                    <br />
                    <br />
                    </>
                  }

                  {!isRendaIdentificada && <>
                    <strong>Renda atualizada automaticamente pelo Governo Federal</strong>
                    <br />
                    <br />
                    Permite ver as rendas que o Governo Federal colocou automaticamente no Cadastro Único da sua família. Isso quer dizer que o cadastro não foi alterado pela família ou pelo município, e sim diretamente pelo Governo Federal.
                    São rendas de trabalho ou benefícios pagos pelo INSS que foram identificadas no CNIS nos últimos 12 meses e já incluídas no Cadastro Único. Se você não teve nenhuma renda alterada automaticamente pelo Governo Federal, essa opção não será exibida.
                    <br />
                    <br />
                    <br />
                    </>
                  }

                  <strong>Período de referência</strong>
                  <br />
                  <br />
                  Informação do mês em que foi identificada a informação do CNIS.
                  <br />
                  <br />
                  <br />
                  <strong>Renda de emprego formal</strong>
                  <br />
                  <br />
                  Exibe as rendas recebidas pelo trabalhador com carteira de trabalho assinada ou do serviço público.<br />
                  <br />- Sua remuneração de trabalho no mês anterior foi de: traz a renda bruta recebida no último mês disponível no CNIS no período de referência. Essa renda normalmente é de dois meses atrás. A renda bruta
                  é o salário sem desconto de previdência, imposto de renda ou outros.
                  <br /><br />- Nos últimos 12 meses, você teve mês/meses de trabalho remunerado: mostra a quantidade de meses em que a pessoa trabalhou nesse período.<br />
                  <br />- Sua remuneração bruta de todos os trabalhos nesse período foi de: soma de tudo que a pessoa recebeu nesse período, sem descontos.<br/>
                  <br />
                  <br />
                  <strong>Empregadores</strong>
                  <br />
                  <br />
                  Exibe os empregadores identificados nos últimos 12 meses, com a data de início do vínculo (data de admissão), data de dispensa (data de rescisão), a ocupação declarada pelo empregador, e os salários brutos
                  recebidos em cada mês.
                  <br />
                  <br />
                  <br />
                  <strong>Benefícios do trabalho</strong>
                  <br />
                  <br />
                  Exibe benefícios pagos pelo INSS, quando a pessoa está de licença do trabalho, tais como salário maternidade, auxílio doença e outros.
                  <br />
                  <br />
                  <br />
                  <strong>Benefícios previdenciários ou BPC/LOAS</strong>
                  <br />
                  <br />
                  Exibe informações de benefícios pagos pelo INSS, podendo ser previdenciários, como aposentadoria ou pensão, ou BPC/LOAS (Benefício de Prestação Continuada da Assistência Social) recebidos pelo cidadão.
                  Para mais informações, consulte o INSS, por meio do telefone gratuito 135 ou do aplicativo Meu INSS.
                  <br />
                  <br />
                  <br />
                  {isRendaIdentificada && <><strong>Seguro desemprego ou defeso</strong>
                  <br />
                  <br />
                  Exibe informações de seguro-desemprego, benefício temporário pago ao trabalhador dispensado sem justa causa, ou do seguro defeso, benefício pago ao pescador artesanal, que fica proibido de pescar durante
                  o período de defeso de alguma espécie. Para mais informações, consulte o INSS, por meio do telefone gratuito 135 ou do aplicativo Meu INSS.
                  <br />
                  <br />
                  <br /></>}
                  <strong>Outras fontes</strong>
                  <br />
                  <br />
                  Exibe outras fontes de remuneração, como Auxílio Inclusão, pago para pessoas com deficiência, ou Auxílio Reclusão, pago para familiares de presos que contribuíam com a Previdência Social. Para mais informações,
                  consulte o INSS, por meio do telefone gratuito 135 ou do aplicativo Meu INSS.
                </div>
              </AjudaRapida>
            </>
          }
      </div>
    </MainContainer>
  );
};

export default RendaCnis;
